import * as Types from '../../../gql/types2';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {"context":{"clientName":"graphql2"}} as const;
export type CustomerSearchQueryVariables = Types.Exact<{
  input: Types.CustomersSearchArgsInput;
}>;


export type CustomerSearchQuery = { __typename?: 'QueryModel', customers: { __typename?: 'CustomersQueryModel2', search: { __typename?: 'ConnectionOfCustomer', token?: string | null, records: Array<{ __typename?: 'Customer', status: Types.CustomerStatus, name: string, zip: string, country: string, state: string, address1: string, address2: string, city: string, fax: string, createCustomerRequestId: any, number?: string | null, simplifiedName: string, notes: string, phone: string, nmTaxable: boolean, electronicInvoicingSystem?: Types.ElectronicInvoicingSystem | null }> } } };


export const CustomerSearchDocument = gql`
    query CustomerSearch($input: CustomersSearchArgsInput!) {
  customers {
    search(input: $input) {
      token
      records {
        status
        name
        zip
        country
        state
        address1
        address2
        city
        fax
        createCustomerRequestId
        number
        simplifiedName
        notes
        phone
        nmTaxable
        electronicInvoicingSystem
      }
    }
  }
}
    `;

/**
 * __useCustomerSearchQuery__
 *
 * To run a query within a React component, call `useCustomerSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerSearchQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCustomerSearchQuery(baseOptions: Apollo.QueryHookOptions<CustomerSearchQuery, CustomerSearchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomerSearchQuery, CustomerSearchQueryVariables>(CustomerSearchDocument, options);
      }
export function useCustomerSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomerSearchQuery, CustomerSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomerSearchQuery, CustomerSearchQueryVariables>(CustomerSearchDocument, options);
        }
export type CustomerSearchQueryHookResult = ReturnType<typeof useCustomerSearchQuery>;
export type CustomerSearchLazyQueryHookResult = ReturnType<typeof useCustomerSearchLazyQuery>;
export type CustomerSearchQueryResult = Apollo.QueryResult<CustomerSearchQuery, CustomerSearchQueryVariables>;